import Grid from '../grid/grid';

const GridForm = Grid.withComponent('form');

export default GridForm;
